var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.25590",
      "ably-hubspot-js": "static-2.2702",
      "breadcrumbs-ui": "static-1.776",
      "enviro": "static-4.284",
      "head-dlb": "static-1.3234",
      "hs-lodash": "static-4.40",
      "hs-promise-utils": "static-1.3595",
      "hs-test-utils": "static-1.6088",
      "hub-http": "static-1.4150",
      "hubspot-url-utils": "static-1.2588",
      "HubStyleTokens": "static-2.9628",
      "I18n": "static-7.1333",
      "jasmine-runner": "static-1.4482",
      "nav-client-types": "static-1.585",
      "nav-meta": "static-1.24383",
      "navigation-messaging": "static-1.2073",
      "navigation-components": "static-1.12746",
      "navigation-components-tests": "static-1.9356",
      "quartz": "static-1.4826",
      "react": "static-7.147",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "rpc-client-utils": "static-1.2852",
      "target-element-observer": "static-1.152",
      "webpack-env": "static-1.50",
      "wootric-nps": "static-1.5130",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.29200",
      "classnames": "static-2.10",
      "crosstab": "static-1.2733",
      "ExtensionInstallHelpers": "static-1.517",
      "foundations-components": "static-1.5163",
      "foundations-theming": "static-1.2318",
      "foundations-theming-base": "static-1.1303",
      "foundations-theming-specialty": "static-1.35",
      "frontend-preferences-client": "static-1.5993",
      "global-search-externals": "static-1.8565",
      "idb-keyval": "static-1.18",
      "magpie-lib": "static-1.3721",
      "magpie-types": "static-1.3181",
      "metrics-js": "static-1.7864",
      "nav-onboarding-tours": "static-1.1432",
      "notification-sounds": "static-1.2566",
      "prefetcher": "static-1.3875",
      "react-dom": "static-7.85",
      "react-utils": "static-2.3755",
      "redux-thunk": "static-2.43",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.6309",
      "simple-logging-lib": "static-1.1180",
      "styled-components": "static-2.40",
      "superstore": "static-1.2903",
      "trial-components-library": "static-1.9775",
      "ts-schema": "static-1.2579",
      "ui-images": "static-2.777",
      "usage-tracker-core": "static-1.5441",
      "hs-promise-rejection-tracking": "static-1.3563",
      "PortalIdParser": "static-2.263",
      "raven": "static-3.3936",
      "raven-hubspot": "static-1.4243",
      "bend-plugin-trellis-migration": "static-1.1848",
      "moment": "static-3.26",
      "quartz-core": "static-1.4045",
      "HeadJS": "static-2.534",
      "framer-motion": "static-1.38",
      "hs-test-utils-bend-plugin": "static-1.1199",
      "msw": "static-1.39",
      "testing-library": "static-1.118",
      "i18n-data": "static-1.193",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.2477",
      "quartz-core-utils": "static-1.1693",
      "StyleGuideUI": "static-3.441",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "quick-fetch": "static-1.2224",
      "HubStyle": "static-2.9937",
      "calling-error-reporting": "static-1.29206",
      "calling-usage-tracker": "static-1.4595",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "self-service-api": "static-1.8227",
      "SharedI18nStrings": "static-1.160",
      "UIComponents": "static-3.6577",
      "bend-plugin-foundations-components": "static-1.1431",
      "floating-ui": "static-1.24",
      "foundations-assets": "static-1.2999",
      "hs-story-utils": "static-1.7388",
      "react-aria": "static-1.36",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.71",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.328",
      "bend-plugin-foundations-theming": "static-1.801",
      "global-search-shared": "static-1.9277",
      "usage-tracker": "static-1.5591",
      "autolinker": "static-3.11",
      "sanitize": "static-1.2486",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.4334",
      "atom": "static-1.3446",
      "copilot-toolkit": "static-1.4023",
      "demographics-client": "static-1.3524",
      "icons": "static-2.587",
      "laboratory-lib": "static-3.5379",
      "onboarding-scopes": "static-1.4679",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.495",
      "signup-constants": "static-1.14952",
      "trials-service-types": "static-1.2284",
      "ui-addon-i18n": "static-1.9009",
      "ui-addon-upgrades": "static-9.15080",
      "user-context": "static-1.3260",
      "dispatcher": "static-1.108",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.603",
      "hub-http-shared-msw-handlers": "static-1.6217",
      "hubspotter-http": "static-1.2960",
      "hubspotter-http-shared-msw-handlers": "static-1.6215",
      "mobile-manifest-mixins": "static-1.305",
      "platform-navigation-bootstrap": "static-1.10287",
      "react-rhumb": "static-1.14698",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.328",
      "customer-data-ui-utilities": "static-1.7835",
      "ai-addon-copilot-preview": "static-1.3546",
      "apollo-link-hub-http": "static-2.2919",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.7603",
      "graphql": "static-1.56",
      "search-service-types": "static-1.2221",
      "chatspot-client-types": "static-1.7530",
      "chatspot-core": "static-1.13225",
      "ContentUtils": "static-1.61085",
      "sassPrefix": "static-1.125",
      "feature-store-service-types": "static-1.2876",
      "growth-monetization-service-types": "static-1.2883",
      "upgrade-management-service-types": "static-1.2867",
      "getting-started-shared-tasks": "static-1.9335",
      "getting-started-shared-tasks-store": "static-1.8453",
      "platform-infra-nav-components": "static-1.6091",
      "react-dnd-compat": "static-1.2665",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.4910",
      "apollo-dlb": "static-3.41",
      "cms-field-types": "static-1.2912",
      "content-icons-ui": "static-1.1833",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.7538",
      "ui-addon-react-router-dom": "static-1.7721",
      "usage-tracker-container": "static-1.5581"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.25590",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.2702",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.776",
      "enviro": "/enviro/static-4.284",
      "head-dlb": "/head-dlb/static-1.3234",
      "hs-lodash": "/hs-lodash/static-4.40",
      "hs-promise-utils": "/hs-promise-utils/static-1.3595",
      "hs-test-utils": "/hs-test-utils/static-1.6088",
      "hub-http": "/hub-http/static-1.4150",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2588",
      "HubStyleTokens": "/HubStyleTokens/static-2.9628",
      "I18n": "/I18n/static-7.1333",
      "jasmine-runner": "/jasmine-runner/static-1.4482",
      "nav-client-types": "/nav-client-types/static-1.585",
      "nav-meta": "/nav-meta/static-1.24383",
      "navigation-messaging": "/navigation-messaging/static-1.2073",
      "navigation-components": "/navigation-components/static-1.12746",
      "navigation-components-tests": "/navigation-components-tests/static-1.9356",
      "quartz": "/quartz/static-1.4826",
      "react": "/react/static-7.147",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "rpc-client-utils": "/rpc-client-utils/static-1.2852",
      "target-element-observer": "/target-element-observer/static-1.152",
      "webpack-env": "/webpack-env/static-1.50",
      "wootric-nps": "/wootric-nps/static-1.5130",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.29200",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.2733",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.517",
      "foundations-components": "/foundations-components/static-1.5163",
      "foundations-theming": "/foundations-theming/static-1.2318",
      "foundations-theming-base": "/foundations-theming-base/static-1.1303",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.35",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.5993",
      "global-search-externals": "/global-search-externals/static-1.8565",
      "idb-keyval": "/idb-keyval/static-1.18",
      "magpie-lib": "/magpie-lib/static-1.3721",
      "magpie-types": "/magpie-types/static-1.3181",
      "metrics-js": "/metrics-js/static-1.7864",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.1432",
      "notification-sounds": "/notification-sounds/static-1.2566",
      "prefetcher": "/prefetcher/static-1.3875",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.3755",
      "redux-thunk": "/redux-thunk/static-2.43",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.6309",
      "simple-logging-lib": "/simple-logging-lib/static-1.1180",
      "styled-components": "/styled-components/static-2.40",
      "superstore": "/superstore/static-1.2903",
      "trial-components-library": "/trial-components-library/static-1.9775",
      "ts-schema": "/ts-schema/static-1.2579",
      "ui-images": "/ui-images/static-2.777",
      "usage-tracker-core": "/usage-tracker-core/static-1.5441",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3563",
      "PortalIdParser": "/PortalIdParser/static-2.263",
      "raven": "/raven/static-3.3936",
      "raven-hubspot": "/raven-hubspot/static-1.4243",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1848",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4045",
      "HeadJS": "/HeadJS/static-2.534",
      "framer-motion": "/framer-motion/static-1.38",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1199",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.118",
      "i18n-data": "/i18n-data/static-1.193",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.2477",
      "quartz-core-utils": "/quartz-core-utils/static-1.1693",
      "StyleGuideUI": "/StyleGuideUI/static-3.441",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "quick-fetch": "/quick-fetch/static-1.2224",
      "HubStyle": "/HubStyle/static-2.9937",
      "calling-error-reporting": "/calling-error-reporting/static-1.29206",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.4595",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "self-service-api": "/self-service-api/static-1.8227",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
      "UIComponents": "/UIComponents/static-3.6577",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.1431",
      "floating-ui": "/floating-ui/static-1.24",
      "foundations-assets": "/foundations-assets/static-1.2999",
      "hs-story-utils": "/hs-story-utils/static-1.7388",
      "react-aria": "/react-aria/static-1.36",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.71",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.328",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.801",
      "global-search-shared": "/global-search-shared/static-1.9277",
      "usage-tracker": "/usage-tracker/static-1.5591",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.2486",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.4334",
      "atom": "/atom/static-1.3446",
      "copilot-toolkit": "/copilot-toolkit/static-1.4023",
      "demographics-client": "/demographics-client/static-1.3524",
      "icons": "/icons/static-2.587",
      "laboratory-lib": "/laboratory-lib/static-3.5379",
      "onboarding-scopes": "/onboarding-scopes/static-1.4679",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.495",
      "signup-constants": "/signup-constants/static-1.14952",
      "trials-service-types": "/trials-service-types/static-1.2284",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9009",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15080",
      "user-context": "/user-context/static-1.3260",
      "dispatcher": "/dispatcher/static-1.108",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.603",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6217",
      "hubspotter-http": "/hubspotter-http/static-1.2960",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6215",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.305",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10287",
      "react-rhumb": "/react-rhumb/static-1.14698",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.328",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.7835",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.3546",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.2919",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.7603",
      "graphql": "/graphql/static-1.56",
      "search-service-types": "/search-service-types/static-1.2221",
      "chatspot-client-types": "/chatspot-client-types/static-1.7530",
      "chatspot-core": "/chatspot-core/static-1.13225",
      "ContentUtils": "/ContentUtils/static-1.61085",
      "sassPrefix": "/sassPrefix/static-1.125",
      "feature-store-service-types": "/feature-store-service-types/static-1.2876",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.2883",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.2867",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.9335",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.8453",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6091",
      "react-dnd-compat": "/react-dnd-compat/static-1.2665",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.4910",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "cms-field-types": "/cms-field-types/static-1.2912",
      "content-icons-ui": "/content-icons-ui/static-1.1833",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.7538",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7721",
      "usage-tracker-container": "/usage-tracker-container/static-1.5581"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};